import { Fragment, h } from '@stencil/core';
import omit from 'lodash/omit';
import { CircularProductTypes, pesCatalogPageTypes, PRODUCT, LINK_TYPES, ECarouselRelation, ConfiguratorHandler, setLinearProductData, store, tryParse } from '@pes-ui/utils';
import { isEqual } from 'lodash';
import { PesRouterStore } from '../../index';
import PesRoute from '../pes-router/pes-route';
import { getCustomAddToCartSettings, getCustomAddToFavoritesSettings, getIsCustomAddToCartEnabled, getIsCustomAddToFavoritesEnabled, getIsProductsInCustomCart, navigateWithRouter, } from '../pes-router/utils';
import { getFilteredBreadcrumbs } from '../breadcrumbs/utils';
const defaultStatus = {
  isLoading: {
    all: true,
    ddc: true,
  },
  error: {
    all: false,
    ddc: false,
  },
};
const propsToParse = [
  { prop: '_showBreadcrumbs', target: 'showBreadcrumbs' },
  { prop: '_allData', target: 'allData' },
  { prop: '_isPBS', target: 'isPBS' },
  { prop: '_productId', target: 'productId' },
  { prop: '_countryCode', target: 'countryCode' },
  { prop: '_languageCode', target: 'languageCode' },
  { prop: '_epdsData', target: 'epdsData' },
  { prop: '_ddc', target: 'ddc' },
  { prop: '_localeCode', target: 'localeCode' },
  { prop: '_enableCommerceConnector', target: 'enableCommerceConnector' },
  { prop: '_showBuyOnline', target: 'showBuyOnline' },
  { prop: '_showCompare', target: 'showCompare' },
  { prop: '_showCustomPrice', target: 'showCustomPrice' },
  { prop: '_showFaq', target: 'showFaq' },
  { prop: '_migration', target: 'migration' },
  { prop: '_status', target: 'status' },
];
export class PesAppPdp {
  constructor() {
    var _a;
    this.hyperPersonalizationFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.hyperPersonalization;
    this.isHyperPersonalizationEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.hyperPersonalizationFlag || {});
    this._showBreadcrumbs = undefined;
    this._allData = undefined;
    this._productId = undefined;
    this._epdsData = undefined;
    this._ddc = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._localeCode = undefined;
    this._isPBS = undefined;
    this._enableCommerceConnector = undefined;
    this._showBuyOnline = undefined;
    this._showFaq = undefined;
    this._showCompare = undefined;
    this._showCustomPrice = undefined;
    this._migration = undefined;
    this._status = undefined;
    this.productId = undefined;
    this.localeCode = undefined;
    this.productCtas = undefined;
    this.allData = undefined;
    this.epdsData = undefined;
    this.status = defaultStatus;
    this.enableCommerceConnector = undefined;
    this.showBuyOnline = undefined;
    this.showBreadcrumbs = undefined;
    this.showFaq = undefined;
    this.showCompare = undefined;
    this.showCustomPrice = undefined;
    this.customPrice = undefined;
    this.ddc = undefined;
    this.isPBS = false;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.host = undefined;
    this.migration = undefined;
    this.storageName = '';
    this.stickyBarComponent = null;
  }
  componentWillRender() {
    if (!this.isPBS)
      return;
    PesRouterStore.set('productCTAs', this.productCtas);
    PesRouterStore.set('showCustomPrice', this.showCustomPrice);
    PesRouterStore.set('customPrice', this.customPrice);
  }
  componentWillLoad() {
    propsToParse.forEach(({ prop, target }) => {
      var _a;
      this[target] = ((_a = tryParse(this[prop])) !== null && _a !== void 0 ? _a : this[target]);
    });
    if (this.isPBS)
      PesRouterStore.set('enableAppRouting', true);
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  componentDidLoad() {
    this.stickyBarComponent = this.stickyBarRef;
  }
  watchProductCtas(newValue, oldValue) {
    if (isEqual(oldValue, newValue)) {
      return;
    }
    PesRouterStore.set('productCTAs', newValue);
    const { data } = store.getState().product;
    if (!data) {
      return;
    }
    const updatedBase = Object.assign(Object.assign({}, data[CircularProductTypes.LINEAR].base), { ctaArea: this.productMainAreaCTAData, links: this.customLinks, offlineStores: this.customOfflineStores });
    const updatedProductData = Object.assign(Object.assign({}, data[CircularProductTypes.LINEAR]), { base: updatedBase });
    store.dispatch(setLinearProductData(updatedProductData));
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: getFilteredBreadcrumbs((_a = this.allData) === null || _a === void 0 ? void 0 : _a.breadcrumbs, this.isPBS ? undefined : []),
    };
  }
  get productMainAreaCTAData() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const mainAreaCTAData = Object.assign(Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.ctaArea), { buttons: {} });
    const defaultButtons = ((_b = this.allData) === null || _b === void 0 ? void 0 : _b.base.ctaArea.buttons) || {};
    if (getIsCustomAddToCartEnabled() || this.migration) {
      let defaultLabel = (_d = (_c = getCustomAddToCartSettings()) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.addLabel;
      if (getIsProductsInCustomCart([this.productId])) {
        defaultLabel = (_f = (_e = getCustomAddToCartSettings()) === null || _e === void 0 ? void 0 : _e.labels) === null || _f === void 0 ? void 0 : _f.removeLabel;
      }
      mainAreaCTAData.buttons["ADD_TO_CART_BUTTON"] = {
        labels: {
          defaultLabel: defaultLabel || ((_g = this.allData) === null || _g === void 0 ? void 0 : _g.addToCartLabel),
        },
      };
    }
    if (this.showBuyOnline
      && ((_j = (_h = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.defaultLabel)) {
      mainAreaCTAData.buttons["BUY_ONLINE_BUTTON_REGULAR"] = {
        labels: {
          defaultLabel: (_l = (_k = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _k === void 0 ? void 0 : _k.labels) === null || _l === void 0 ? void 0 : _l.defaultLabel,
        },
      };
    }
    if (this.showBuyOnline
      && ((_o = (_m = defaultButtons["BUY_MARKETPLACE_BUTTON_REGULAR"]) === null || _m === void 0 ? void 0 : _m.labels) === null || _o === void 0 ? void 0 : _o.defaultLabel)) {
      mainAreaCTAData.buttons["BUY_MARKETPLACE_BUTTON_REGULAR"] = Object.assign({}, defaultButtons["BUY_MARKETPLACE_BUTTON_REGULAR"]);
    }
    if ("DOWNLOAD_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["DOWNLOAD_BUTTON"] = defaultButtons["DOWNLOAD_BUTTON"];
    }
    if ("NOTIFY_ME_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["NOTIFY_ME_BUTTON"] = defaultButtons["NOTIFY_ME_BUTTON"];
    }
    return mainAreaCTAData;
  }
  get customLinks() {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!this.isPBS)
      return ((_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.links) || {};
    const links = {};
    if (getIsCustomAddToFavoritesEnabled()) {
      links[LINK_TYPES.ADD_TO_MY_PRODUCTS] = {
        labels: {
          defaultLabel: ((_b = getCustomAddToFavoritesSettings().labels) === null || _b === void 0 ? void 0 : _b.addLabel) || ((_c = this.allData) === null || _c === void 0 ? void 0 : _c.addToFavoritesLabel),
          removeLabel: ((_d = getCustomAddToFavoritesSettings().labels) === null || _d === void 0 ? void 0 : _d.removeLabel)
            || ((_e = getCustomAddToFavoritesSettings().labels) === null || _e === void 0 ? void 0 : _e.addLabel)
            || ((_f = this.allData) === null || _f === void 0 ? void 0 : _f.removeFromFavoritesLabel),
        },
      };
    }
    if (this.showCompare) {
      links[LINK_TYPES.COMPARE] = {
        labels: { defaultLabel: (_g = this.allData) === null || _g === void 0 ? void 0 : _g.base.links.COMPARE.labels.defaultLabel },
      };
    }
    return links;
  }
  get customOfflineStores() {
    var _a, _b;
    if (!this.isPBS)
      return ((_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.offlineStores) || {};
    return omit((_b = this.allData) === null || _b === void 0 ? void 0 : _b.base.offlineStores, 'findResellerLink');
  }
  render() {
    var _a, _b, _c;
    if (this.status.isLoading.all) {
      return h("pdp-skeleton", null);
    }
    if (!this.allData)
      return;
    if (typeof this.status.error.all === 'object') {
      const route = new PesRoute({ page: pesCatalogPageTypes.ALL_PRODUCTS });
      navigateWithRouter(route, this.el);
    }
    const { useNewUiForLifecycle } = this.allData.config;
    const pageData = {
      hostWithLocale: this.storageName,
      pageType: PRODUCT,
      pageId: this.productId,
    };
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { shouldSetupMedalliaSurvey: true, hideOnMobile: true, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.storageName }))), h("slot", { name: "promotion-banner-pilot" }), h("pes-product-main", Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base, { productId: this.productId, productSoftwareDocuments: (_c = (_b = this.allData) === null || _b === void 0 ? void 0 : _b.base) === null || _c === void 0 ? void 0 : _c.softwareDocuments, productCR: this.productId, localeCode: this.localeCode, ctaArea: this.productMainAreaCTAData, links: this.customLinks, offlineStores: this.customOfflineStores, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, countryCode: this.countryCode, class: "pes-app-pdp__section", isPBS: this.isPBS, host: this.host, languageCode: this.languageCode, stickyBarRef: this.stickyBarRef, migration: this.migration }), h("slot", { name: "discounted-price", slot: "discounted-price" })), h("div", { ref: (element) => (this.stickyBarRef = element) }, this.isHyperPersonalizationEnabled
      && (h("pes-recommendations", { class: 'product-page-recommendations', pageType: pesCatalogPageTypes.PRODUCT, pageId: this.productId, countryCode: this.countryCode, languageCode: this.languageCode, isLoggedIn: this.isPBS })), h("pes-asset-bar-and-related-products", Object.assign({}, this.allData.assetBarRelatedProducts, { localeCode: this.localeCode, class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.compatibleSoftware }, this.allData.compatibleSoftware, pageData, { class: "pes-app-pdp__section" })), h("pes-lifecycle-services-wrapper", Object.assign({}, this.allData.crossSellLife, { useNewUiForLifecycle: !!useNewUiForLifecycle, countryCode: this.countryCode, languageCode: this.languageCode, class: "pes-app-pdp__section" })), h("pes-description-and-specifications", Object.assign({}, this.allData.specifications, { class: "pes-app-pdp__section" })), h("pes-environmental-data", Object.assign({}, this.allData.environmentalData, { class: "pes-app-pdp__section" })), h("pes-epds", { epds: this.epdsData, class: "pes-app-pdp__section" }), this.ddc && (h("pes-product-documents-and-software", Object.assign({}, this.ddc, { class: "pes-app-pdp__section" }))), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.upsell }, this.allData.upsell, pageData, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.crosssell }, this.allData.crosssell, pageData, { class: "pes-app-pdp__section" })), this.showFaq && h("pes-faq", Object.assign({}, this.allData.faq, { class: "pes-app-pdp__section" })))));
  }
  static get is() { return "pes-app-spryker-pdp"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-app-spryker-pdp.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-app-spryker-pdp.css"]
    };
  }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_allData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-all-data",
        "reflect": false
      },
      "_productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-id",
        "reflect": false
      },
      "_epdsData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-epds-data",
        "reflect": false
      },
      "_ddc": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-ddc",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "_enableCommerceConnector": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-enable-commerce-connector",
        "reflect": false
      },
      "_showBuyOnline": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-buy-online",
        "reflect": false
      },
      "_showFaq": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-faq",
        "reflect": false
      },
      "_showCompare": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-compare",
        "reflect": false
      },
      "_showCustomPrice": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-custom-price",
        "reflect": false
      },
      "_migration": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-migration",
        "reflect": false
      },
      "_status": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-status",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The ID of the product."
        },
        "attribute": "product-id",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defined locale code. E.g.: fr/fr"
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines CTA config which is used to set up CTAs buttons"
        }
      },
      "allData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.GetProductsAllResponse | null",
          "resolved": "{ addToCartLabel: string; addToFavoritesLabel: string; removeFromFavoritesLabel: string; breadcrumbs: TBreadcrumbs[]; compatibleSoftware: IProductsCarouselData; crossSellLife: IProductsCarouselData; crosssell: IProductsCarouselData; upsell: IProductsCarouselData; assetBarRelatedProducts: { assetBar: TAssetBarData; productRelations: TRelatedProductsData; productId: string; tabTitle: string; }; sustainability: TSustainability; environmentalData: TEnvironmentalData; specifications: TProductSpecifications; faq: TFaq; base: { productId: string; localeCode: string; ctaArea: TCtaData; links: Record<string, TCtaButton>; labels: Record<string, string>; productStatus: ProductStatus; substitutions: SubstitutionInfo; productMedia: ProductMedia; variants: TProductVariants; masterRange: TMasterRange; productInfo: TProductInfo; highlightedCharacteristics: THighlightedCharacteristics; offlineStores: OfflineStores; materialPriceGroup: TMaterialPriceGroup; environmentalData: TEnvironmentalTopBlock; productSelectorConfig: THpcProductSelectorConfig; rangeSelectorConfig: TScProductSelectorConfig; bulletPoints: TBulletPointItem[]; bulletPointsLimit: number; alternatives: Alternatives; co2Message?: string; circularProductRelationships?: CircularProductRelationships; circularEconomy?: CircularEconomyNew; softwareDocuments?: SoftwareDocument[]; }; recentlyViewedConfig: RecentlyViewedConfig; config: TContext; metaTags?: MetaTags; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "epdsData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ExpAPI.getMain['epds'] | null",
          "resolved": "EpdsContent[]",
          "references": {
            "ExpAPI": {
              "location": "import",
              "path": "../../global-types/api/exp-api"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "status": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TStatus",
          "resolved": "{ isLoading: { all: boolean; ddc: boolean; }; error: { all: boolean | { code: number; }; ddc: boolean | { code: number; }; }; }",
          "references": {
            "TStatus": {
              "location": "import",
              "path": "../pes-app-pdp/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Status of requests for different parts of PDP."
        },
        "defaultValue": "defaultStatus"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether Commerce Connector is enabled"
        },
        "attribute": "enable-commerce-connector",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show buy online button"
        },
        "attribute": "show-buy-online",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "showFaq": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-faq",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false
      },
      "showCustomPrice": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-custom-price",
        "reflect": false
      },
      "customPrice": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCustomPrice",
          "resolved": "{ price?: number; currencyCode?: string; localizedPrice?: string; }",
          "references": {
            "TCustomPrice": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ddc": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "DDCProps",
          "resolved": "DDCProps",
          "references": {
            "DDCProps": {
              "location": "import",
              "path": "../../globals/ddc"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://se.com"
            }],
          "text": "host"
        },
        "attribute": "host",
        "reflect": false
      },
      "migration": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "migration",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "storageName": {},
      "stickyBarComponent": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "productCtas",
        "methodName": "watchProductCtas"
      }];
  }
}
